export default __webpack_public_path__ + "static/media/park3.3f205110.png";